import { useState } from "react";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { API } from "@/lib/constants";

const QuoteForm = ({ onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    service_type: "",
    message: ""
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/quotes`, formData);
      toast.success("Quote request submitted! We'll contact you soon.");
      setFormData({ name: "", email: "", phone: "", service_type: "", message: "" });
      if (onClose) onClose();
    } catch (error) {
      toast.error("Failed to submit. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Input
          data-testid="quote-name-input"
          placeholder="Your Name *"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          required
          className="h-12 rounded-none border-gray-200 focus:border-[#0F4C81] font-body"
        />
        <Input
          data-testid="quote-email-input"
          type="email"
          placeholder="Email Address *"
          value={formData.email}
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
          required
          className="h-12 rounded-none border-gray-200 focus:border-[#0F4C81] font-body"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Input
          data-testid="quote-phone-input"
          type="tel"
          placeholder="Phone Number *"
          value={formData.phone}
          onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
          required
          className="h-12 rounded-none border-gray-200 focus:border-[#0F4C81] font-body"
        />
        <Select
          value={formData.service_type}
          onValueChange={(value) => setFormData({ ...formData, service_type: value })}
          required
        >
          <SelectTrigger data-testid="quote-service-select" className="h-12 rounded-none border-gray-200 font-body">
            <SelectValue placeholder="Select Service *" />
          </SelectTrigger>
          <SelectContent position="popper" sideOffset={4}>
            <SelectItem value="frameless-shower">Frameless Shower</SelectItem>
            <SelectItem value="semi-frameless-shower">Semi-Frameless Shower</SelectItem>
            <SelectItem value="sliding-shower">Sliding Shower</SelectItem>
            <SelectItem value="window-replacement">Window Replacement</SelectItem>
            <SelectItem value="mirrors">Custom Mirrors</SelectItem>
            <SelectItem value="commercial">Commercial Glass</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <Textarea
        data-testid="quote-message-input"
        placeholder="Tell us about your project..."
        value={formData.message}
        onChange={(e) => setFormData({ ...formData, message: e.target.value })}
        className="min-h-[120px] rounded-none border-gray-200 focus:border-[#0F4C81] font-body resize-none"
      />
      <Button
        data-testid="quote-submit-button"
        type="submit"
        disabled={loading || !formData.service_type}
        className="w-full h-14 bg-[#0F4C81] hover:bg-[#0A355C] text-white rounded-full font-body font-semibold text-base transition-all duration-300"
      >
        {loading ? "Submitting..." : "Request Free Quote"}
      </Button>
    </form>
  );
};

export default QuoteForm;
